import { ExtranetContainer, useLanguage } from '@pharmac-extranet/shared'
import { PharmacH2, PharmacH4, PharmacText } from '@pharmac/ui'
import { useEffect, useRef } from 'react'
import { ExtranetGradient } from '../components/extranet/ExtranetGradient'
import { useAuthenticationContext } from '../features/authentication/useAuthentication'

export const UnauthorizedView = () => {
  const timeoutRef = useRef<null | NodeJS.Timeout>()
  const { t } = useLanguage()

  const { doLogout } = useAuthenticationContext()

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(
      () =>
        doLogout({
          redirectUri: window.location.origin,
        }),
      10000
    )

    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [])

  return (
    <ExtranetGradient>
      <ExtranetContainer flexColumn>
        <PharmacH2
          color="white"
          marginLargeBottom
        >
          {t('extranet:unauthorized.noAuth')}
        </PharmacH2>
        <PharmacH4
          color="white"
          marginLargeBottom
        >
          {t('extranet:unauthorized.noLink')}
        </PharmacH4>
        <PharmacText color="white">{t('extranet:unauthorized.redirect')}</PharmacText>
      </ExtranetContainer>
    </ExtranetGradient>
  )
}
